import { render, staticRenderFns } from "./step10.vue?vue&type=template&id=1f127ddb&scoped=true&"
import script from "./step10.vue?vue&type=script&lang=js&"
export * from "./step10.vue?vue&type=script&lang=js&"
import style0 from "./step10.vue?vue&type=style&index=0&id=1f127ddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f127ddb",
  null
  
)

export default component.exports